import { ChevronRightMini } from '@medusajs/icons';
import clsx from 'clsx';

import BreadcrumbsContainer from './breadcrumbs-container';
import BreadcrumbsItem from './breadcrumbs-item';

export interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => {
  return (
    <div className={className}>
      <BreadcrumbsContainer separator={<ChevronRightMini />}>
        {items.map((item, idx) => (
          <BreadcrumbsItem
            key={item.href || item.name}
            href={item.href}
            className={clsx({
              'text-grey-10': idx === items.length - 1,
            })}
          >
            {item.name}
          </BreadcrumbsItem>
        ))}
      </BreadcrumbsContainer>
    </div>
  );
};

export default Breadcrumbs;
